/**
 * The check number, date and bank recorded with a check payment.
 *
 * Desk payments store them as `metadata.checkDetails.{checkNumber, checkDate,
 * bankName}` (on the payment and on its credit line). The payment pop-up read
 * `metadata.check_number` / `check_date`, which nothing writes, so every check
 * payment showed "N/A" (2026-10-10: 0 rows of the flat shape vs 56 nested on
 * the live club). Read both shapes here, in one place.
 */
export interface CheckDetails {
  checkNumber: string | null;
  checkDate: string | null;
  bankName: string | null;
}

const text = (v: unknown): string | null => {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  return s ? s : null;
};

export function getCheckDetails(metadata: any): CheckDetails {
  const nested = (metadata && typeof metadata.checkDetails === "object" && metadata.checkDetails) || {};
  return {
    checkNumber: text(nested.checkNumber) ?? text(metadata?.check_number),
    checkDate: text(nested.checkDate) ?? text(metadata?.check_date),
    bankName: text(nested.bankName) ?? text(metadata?.bank_name),
  };
}
